<template>
  <Container type="card-full">
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true"
            @cellClick="cellClick" @pagechange="pagechange"
            :editRules="editRules"
            >
        <template slot="btn">
          <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  const SUCCESS = 1
  export default {
    name: 'unitIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        comid: this.$store.getters.loginUser.usercomid,
        list: [],
        cols: [
          { type: 'seq',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'unitname', fieldtype: 'C', title: '名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'unitid', fieldtype: 'C', visible: false}
        ],
        editRules: {
          'unitname': [
            {required: true, message: '输入内容不能为空'},
            {max: 20, message: '最多输入20个字符'},
            {validator: ({ cellValue, rule, rules, row, rowIndex, column, columnIndex }) => {
                return new Promise((resolve, reject)=> {
                  request({
                    url: '/validate/validateData',
                    method: "post",
                    data: {tablename: 'unitrec',checkfield: 'unitname', checkval: cellValue, id: row.unitid, fieldid: 'unitid'}
                  }).then (res => {
                    res === SUCCESS ? reject(Error(`名称不能重复`)) : resolve()
                  })
                })
            }, trigger: 'blur'}
          ]
        },
        unit: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        },
        btnLoading: false,
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delUnit())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getUnitList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init() {
        this.menuid = this.$route.query.menuid
        this.comid = this.$store.getters.loginUser.usercomid
        this.list = []
        this.unit = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delUnit () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/unit/delUnit',
            method: "post",
            data: this.unit
          })
          if (data.issuccess===1) {
            this.getUnitList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.unit = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getUnitList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        if (!await this.$refs.xGrid.validError()) return
        model.comid = this.comid
        let data = await request({
          url: '/basic/unit/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getUnitList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getUnitList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/unit/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
